import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Location } from '../../../classes';

@Component({
  selector: 'app-location-label',
  templateUrl: './location-label.component.html',
  styleUrls: ['./location-label.component.css']
})
export class LocationLabelComponent implements OnChanges {

  @Input() location: Location;
  @Input() headline: string = 'Standort';

  subTitles: string[] = [];

  constructor() { }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if(simpleChanges['location']) this.validate();
  }

  validate(){
    var subTitles = [];
    if(this.location){
      if(this.location.address){
        subTitles.push(`${this.location.address.addressstreet} ${this.location.address.addresshousenumber}`);
        subTitles.push(`${this.location.address.addresszipcode} ${this.location.address.addresscity}`);
      }
      subTitles.push(this.location.locationfloor);
    }
    this.subTitles = subTitles;
  }

}
